<div class="dialog-container">
  <!-- Header -->
  <div
    class="dialog-header d-flex justify-content-between w-100"
    style="display: flex; justify-content: space-between"
  >
    <h2 class="dialog-title">إضافة متابعة</h2>
    <button class="close-btn" (click)="close()">✕</button>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <!-- نوع المتابعة -->
    <div class="form-group">
      <label>نوع المتابعة</label>
      <select [(ngModel)]="selectedFollowUp">
        <option *ngFor="let option of followUpOptions" [value]="option.value">
          {{ option.label }}
        </option>
      </select>
    </div>

    <!-- نص إضافي -->
    <div class="form-group">
      <label>نص إضافي للمتابعة</label>
      <textarea rows="3" [(ngModel)]="note"></textarea>
    </div>

    <!-- تاريخ المتابعة -->
    <div class="form-group">
      <label>تاريخ المتابعة القادمة</label>
      <input type="date" [(ngModel)]="nextDate" />
    </div>
  </div>

  <!-- Actions -->
  <div class="dialog-actions">
    <button class="btn btn-primary" (click)="save()">تسجيل</button>
    <button class="btn btn-secondary" (click)="close()">إغلاق</button>
  </div>
</div>
